<template lang="pug">
  .b-change Сроки изменены
</template>

<script>
export default {
  name: 'TaskChangeDates',
  props: {
    change: Object,
  },
};
</script>

<style scoped lang="scss">

</style>
